import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
Vue.use(require('vue-wechat-title'))

export default new Router({
    mode: 'history',
    base: '/tjkStudy',
    routes: [
        {
            path: '/',
            redirect: '/train/index',
        },{
            path: '/courselist',
            component: () => import('@/page/courseList'),
            name: 'courseList',
            meta: {
                title: '培训中心'
            }
        },
        {
            path: '/video',
            component: () => import('@/page/video'),
            name: 'video',
            meta: {
                title: '视频'
            }
        },
        {
            path: '/signContract',
            component: () => import('@/page/signContract'),
            name: 'signContract',
            meta: {
                title: '签约'
            }
        },
        {
            path: '/courseDetail/:id',
            component: () => import('@/page/courseDetail'),
            name: 'courseDetail',
            meta: {
                title: '课程详情'
            }
        },
        {
            path: '/course',
            component: () => import('@/page/course'),
            name: 'course',
            meta: {
                title: '课程目录'
            }
        },
        {
            path: '/examlist',
            component: () => import('@/page/examList'),
            name: 'examList',
            meta: {
                title: '考试中心'
            }
        },
        {
            path: '/exam/:id',
            component: () => import('@/page/exam'),
            name: 'exam',
            meta: {
                title: '考试答题'
            }
        },
        {
            path: '/examTemp/:id/:trainId',
            component: () => import('@/page/examTemp'),
            name: 'examTemp',
            meta: {
                title: '考试答题2'
            }
        },
        {
            path: '/examTyping/:id',
            component: () => import('@/page/examTyping'),
            name: 'examTyping',
            meta: {
                title: '打字测试'
            }
        },
        {
            path: '/examDetail/:id',
            component: () => import('@/page/examDetail'),
            name: 'examDetail',
            meta: {
                title: '考试详情'
            }
        },
        {
            path: '/examDetailTemp/:id',
            component: () => import('@/page/examDetailTemp'),
            name: 'examDetailTemp',
            meta: {
                title: '考试详情(暂命名)'
            }
        },
        {
            path: '/train/fbtExperienceChoose',
            name: 'fbtExperienceChoose',
            component: () => import('@/page/train/fbtExperienceChoose'),
            meta: {
                title: '淘系认证经验选择'
            }
        },
        {
            path: '/examResult/:id',
            component: () => import('@/page/examResult'),
            name: 'examResult',
            meta: {
                title: '考试结果'
            }
        },
        {
            path: '/typingResult/:id',
            component: () => import('@/page/typingResult'),
            name: 'typingResult',
            meta: {
                title: '考试结果'
            }
        },
        {
            path: '/liveCourse',
            component: () => import('@/page/liveCourse'),
            name: 'liveCourse',
            meta: {
                title: '直播'
            }
        },
        {
            path: '/trainRecords',
            component: () => import('@/page/trainRecords'),
            name: 'trainRecords',
            meta: {
                title: 'APP-我的培训记录'
            }
        },
        {
            path: '/taojinMethod',
            component: () => import('@/page/taojinMethod'),
            name: 'taojinMethod',
            meta: {
                title: '淘金攻略'
            }
        },
        {
            path: '/blacklist',
            component: () => import('@/page/blacklist'),
            name: 'blacklist',
            meta: {
                title: '违规记录'
            }
        },
        {
            path: '/intentRegister',
            component: () => import('@/page/intentRegister'),
            name: 'intentRegister',
            meta: {
                title: '意向登记'
            }
        },
        {
            path: '/groupTrain',
            component: () => import('@/page/college/groupTrain'),
            name: 'groupTrain',
            meta: {
                title: '群培训管理'
            }
        },
        {
            path: '/waitWork',
            component: () => import('@/page/college/waitWork'),
            name: 'waitWork',
            meta: {
                title: '群待岗学员'
            }
        },
        {
            path: '/voiceExam',
            component: () => import('@/page/college/voiceExam'),
            name: 'voiceExam',
            meta: {
                title: '语音考核'
            }
        },
        {
            path: '/tjkExam',
            component: () => import('@/page/college/tjkExam'),
            name: 'tjkExam',
            meta: {
                title: '学员考核'
            }
        },
        {
            path: '/waitWorkExam',
            component: () => import('@/page/college/waitWorkExam'),
            name: 'waitWorkExam',
            meta: {
                title: '群待岗学员群考核'
            }
        },
        {
            path: '/retrialExamine',
            component: () => import('@/page/college/retrialExamine'),
            name: 'retrialExamine',
            meta: {
                title: '建议复训考核'
            }
        },
        {
            path: '/linkage',
            component: () => import('@/page/college/linkage'),
            name: 'linkage',
            meta: {
                title: '联动课程'
            }
        },
        {
            path: '/interview',
            component: () => import('@/page/college/interview'),
            name: 'interview',
            meta: {
                title: '基础面试'
            }
        },
        {
            path: '/interviewTjk/:id/:groupName/:groupId',
            component: () => import('@/page/college/interviewTjk'),
            name: 'interviewTjk',
            meta: {
                title: '申请人详情'
            }
        },
        {
            path: '/groupCheckIn',
            component: () => import('@/page/college/groupCheckIn'),
            name: 'groupCheckIn',
            meta: {
                title: 'teamTalk签到'
            }
        },
        {
            path: '/operatorExamine',
            component: () => import('@/page/provider/operatorExamine'),
            name: 'operatorExamine',
            meta: {
                title: '合伙人运营商考核'
            }
        },
        {
            path: '/enterExam',
            component: () => import('@/page/provider/enterExam'),
            name: 'enterExam',
            meta: {
                title: '语音考核'
            }
        },
        {
            path: '/tjkExamOperator',
            component: () => import('@/page/provider/tjkExamOperator'),
            name: 'tjkExamOperator',
            meta: {
                title: '学员考核'
            }
        },
        // pdd模拟-新版
        {
            path: '/simulate/pddStudy',
            name: 'pddStudy',
            component: () => import('@/page/simulate/pddStudy'),
            meta: {
                title: '拼多多功能学习',
                type: 'pddStudy',
            }
        },
        // pdd模拟-新版
        {
            path: '/simulate/pddExam',
            name: 'pddExam',
            component: () => import('@/page/simulate/pddExam'),
            meta: {
                title: '拼多多模拟实操',
                type: 'pddExam',
            }
        },
        // 聚水潭ERP模拟
        {
            path: '/simulate/jushuitanerpStudy',
            name: 'juShuiTanErpStudy',
            component: () => import('@/page/simulate/juShuiTanErpStudy'),
            meta: {
                title: '聚水潭ERP功能学习',
                type: 'workorderjushuitan',
            }
        },
        {
            path: '/simulate/jushuitanerpexam',
            name: 'juShuiTanErpExam',
            component: () => import('@/page/simulate/juShuiTanErpExam'),
            meta: {
                title: '聚水潭ERP模拟实操',
                type: 'workorderjushuitanexam',
            }
        },
        // 千牛模拟-新版
        {
            path: '/simulate/newqianniu',
            name: 'newQianNiu',
            component: () => import('@/page/simulate/newQianNiu'),
            meta: {
                title: '千牛功能学习',
                type: 'qianniu',
            }
        },
        {
            path: '/simulate/newqianniuexam',
            name: 'newQianNiuExam',
            component: () => import('@/page/simulate/newQianNiuExam'),
            meta: {
                title: '千牛模拟实操',
                type: 'qianniu',
            }
        },
        {
            path: '/simulate/newQianNiuExam_11618',
            name: 'newQianNiuExam_11618',
            component: () => import('@/page/simulate/newQianNiuExam_11618'),
            meta: {
                title: '千牛模拟实操11618',
                type: 'qianniu',
            }
        },
        {
            path: '/simulate/doubleQianNiuExam',
            name: 'doubleQianNiuExam',
            component: () => import('@/page/simulate/doubleQianNiuExam'),
            meta: {
                title: '618双11徽章附加千牛操作',
                type: 'qianniu',
            }
        },
        {
            path: '/simulate/jmStudy',
            name: 'jingMaiStudy',
            component: () => import('@/page/simulate/jingMaiStudy'),
            meta: {
                title: '京麦功能学习',
                type: 'qianniu',
            }
        },
        {
            path: '/simulate/jmExam',
            name: 'jingMaiExam',
            component: () => import('@/page/simulate/jingMaiExam'),
            meta: {
                title: '京麦模拟实操',
                type: 'qianniu',
            }
        },
        {
            path: '/simulate/jmExam_11618',
            name: 'jingMaiExam_11618',
            component: () => import('@/page/simulate/jingMaiExam_11618'),
            meta: {
                title: '京麦模拟实操,双11 618',
                type: 'qianniu',
            }
        },
        //任务培训-签到评价
        {
            path: '/traincheck/index',
            name: 'index',
            component: () => import('@/page/trainCheck/index'),
            meta: {
                title: '签到评价'
            }
        },
        {
            path: '/traincheck/list',
            name: 'list',
            component: () => import('@/page/trainCheck/trainList'),
            meta: {
                title: '培训助手'
            }
        },
        {
            path: '/traincheck/namelist',
            name: 'list',
            component: () => import('@/page/trainCheck/trainNameList'),
            meta: {
                title: '培训名单'
            }
        },
        // 小助手成员管理
        {
            path: '/hawkeye/memberManage',
            name: 'memberManage',
            component: () => import('@/page/hawkeye/memberManage'),
            meta: {
                title: '成员管理'
            }
        },
        // 小助手语音培训考核
        {
            path: '/hawkeye/voiceExam',
            name: 'voiceExam',
            component: () => import('@/page/hawkeye/voiceExam'),
            meta: {
                title: '小助手功能学习'
            }
        },
        {
            path: '/hawkeye/blankLogin',
            name: 'blankLogin',
            component: () => import('@/page/hawkeye/blankLogin'),
            meta: {
                title: '小助手功能学习'
            }
        },
        {
            path: '/hawkeye/voiceTrain',
            name: 'voiceTrain',
            component: () => import('@/page/hawkeye/voiceTrain'),
            meta: {
                title: '岗前培训'
            }
        },
        {
            path: '/wallet',
            name: 'wallet',
            component: () => import('@/page/customerIframe/wallet'),
            meta: {
                title: '我的钱包'
            }
        },
        {
            path: '/voiceExercise',
            name: 'voiceExercise',
            component: () => import('@/page/mobile/voiceExercise'),
            meta: {
                title: '语音对练场'
            }
        },
        {
            path: '/voiceSceneIndex',
            name: 'voiceScene',
            component: () => import('@/page/voiceScene/index'),
            meta: {
                title: '语音陪练'
            }
        },
        {
            path: '/teacherDetail',
            name: 'teacherDetail',
            component: () => import('@/page/voiceScene/teacherDetail'),
            meta: {
                title: '语音陪练'
            }
        },
        {
            path: '/voiceScene/blankLogin',
            name: 'voiceSceneBlankLogin',
            component: () => import('@/page/voiceScene/blankLogin'),
            meta: {
                title: '语音陪练'
            }
        },
        {
            path: '/partner',
            name: 'partner',
            component: () => import('@/page/voiceScene/partner'),
            meta: {
                title: '语音对练'
            }

        },
        {
            path: '/kaoheDetail',
            name: 'kaoheDetail',
            component: () => import('@/page/voiceScene/kaoheDetail'),
            meta: {
                title: '语音考核'
            }
        },
        {
            path: '/kaoheTeacher',
            name: 'kaoheTeacher',
            component: () => import('@/page/voiceScene/kaoheTeacher'),
            meta: {
                title: '语音考核'
            }
        },
        {
            path: '/kaoheTeacherDetail',
            name: 'kaoheTeacherDetail',
            component: () => import('@/page/voiceScene/kaoheTeacherDetail'),
            meta: {
                title: '语音考核'
            }
        },
        //新版小助手嵌套陪练&考核页面
        {
            path: '/newVoiceSceneIndex',
            name: 'newVoiceSceneIndex',
            component: () => import('@/page/newVoiceScene/index'),
            meta: {
                title: '语音陪练'
            }
        },
        {
            path: '/newTeacherDetail',
            name: 'newTeacherDetail',
            component: () => import('@/page/newVoiceScene/teacherDetail'),
            meta: {
                title: '语音陪练'
            }
        },
        {
            path: '/newVoiceScene/blankLogin',
            name: 'newVoiceSceneBlankLogin',
            component: () => import('@/page/newVoiceScene/blankLogin'),
            meta: {
                title: '语音陪练'
            }
        },
        {
            path: '/newPartner',
            name: 'newPartner',
            component: () => import('@/page/newVoiceScene/partner'),
            meta: {
                title: '语音对练'
            }
        },
        {
            path: '/newKaoheDetail',
            name: 'newKaoheDetail',
            component: () => import('@/page/newVoiceScene/kaoheDetail'),
            meta: {
                title: '语音考核'
            }
        },
        {
            path: '/newKaoheTeacher',
            name: 'newKaoheTeacher',
            component: () => import('@/page/newVoiceScene/kaoheTeacher'),
            meta: {
                title: '语音考核'
            }
        },
        {
            path: '/newKaoheTeacherDetail',
            name: 'newKaoheTeacherDetail',
            component: () => import('@/page/newVoiceScene/kaoheTeacherDetail'),
            meta: {
                title: '语音考核'
            }
        },
        {
            path: '/train/blankLogin',
            name: 'trainBlankLogin',
            component: () => import('@/page/train/blankLogin'),
            meta: {
                title: '语音陪练'
            }
        },
        {
            path: '/train/index',
            name: 'trainIndex',
            component: () => import('@/page/train/index'),
            meta: {
                title: '语音/在线客服培训'
            }
        },
        {
            path: '/vedioDetail',
            name: 'vedioDetail',
            component: () => import('@/page/train/vedioDetail'),
            meta: {
                title: '学习课程'
            }
        },
        {
            path: '/webPageLink',
            name: 'webPageLink',
            component: () => import('@/page/train/webPageLink'),
            meta: {
                title: '子页面'
            }
        },
        {
            path: '/train/examDetail',
            name: 'trainExamDetail',
            component: () => import('@/page/train/examDetail'),
            meta: {
                title: '测试课程'
            }
        },
        {
            path: '/train/examResult',
            name: 'trainExamResult',
            component: () => import('@/page/train/examResult'),
            meta: {
                title: '测试课程结果页'
            }
        },
        {
            path: '/train/basicExamDetail/:id',
            name: 'basicExamDetail',
            component: () => import('@/page/train/basicExamDetail'),
            meta: {
                title: '试卷答题详情',
                parentname: '测试课程',
            }
        },
        {
            path: '/train/courseList',
            name: 'trainCourseList',
            component: () => import('@/page/train/courseList'),
            meta: {
                title: '技能提升课程页'
            }
        },
        {
            path: '/train/childCourseList',
            name: 'trainChildCourseList',
            component: () => import('@/page/train/childCourseList'),
            meta: {
                title: '技能提升二级课程页'
            }
        },
        {
            path: '/train/partnerIndex',
            name: 'trainPartnerIndex',
            component: () => import('@/page/train/partnerIndex'),
            meta: {
                title: '技能提升-对练首页'
            }
        },
        {
            path: '/train/recordDetail',
            name: 'recordDetail',
            component: () => import('@/page/train/recordDetail'),
            meta: {
                title: '录音课程'
            }
        },
        {
            path: '/train/eachExerciseRecord',
            name: 'eachExerciseRecord',
            component: () => import('@/page/train/record/eachExerciseRecord'),
            meta: {
                title: '对练记录'
            }
        },
        {
            path: '/train/eachExerciseRecordAll',
            name: 'eachExerciseRecordAll',
            component: () => import('@/page/train/record/eachExerciseRecordAll'),
            meta: {
                title: '对练&扮演客服记录'
            }
        },
        {
            path: '/train/eachRecordDetail',
            name: 'eachRecordDetail',
            component: () => import('@/page/train/record/eachRecordDetail'),
            meta: {
                title: '对练详情'
            }
        },
        {
            path: '/train/examRecordList',
            name: 'examRecordList',
            component: () => import('@/page/train/record/examRecordList'),
            meta: {
                title: '考核记录'
            }
        },
        {
            path: '/train/Secondarylist',
            name: 'Secondarylist',
            component: () => import('@/page/train/newservice/Secondarylist'),
            meta: {
                title: '课程学习'
            }
        },
        {
            path: '/train/Knowledge',
            name: 'Knowledge',
            component: () => import('@/page/train/newservice/Knowledge'),
            meta: {
                title: '新知识点'
            }
        },
        {
            path: '/train/Scene',
            name: 'Scene',
            component: () => import('@/page/train/newservice/Scene'),
            meta: {
                title: '新二级场景'
            }
        },
        {
            path: '/train/SpecialCourses',
            name: 'SpecialCourses',
            component: () => import('@/page/train/newservice/SpecialCourses'),
            meta: {
                title: '新特殊课程'
            }
        },
        {
            path: '/train/CallOutRandomScript',
            name: 'CallOutRandomScript',
            component: () => import('@/page/train/newservice/CallOutRandomScript'),
            meta: {
                title: '随机话术'
            }
        },
        {
            path: '/train/Sessions',
            name: 'Sessions',
            component: () => import('@/page/train/newservice/Sessions'),
            meta: {
                title: '新场景（分上下场）'
            }
        },
        {
            path: '/train/OnInline',
            name: 'OnInline',
            component: () => import('@/page/train/newservice/OnInline'),
            meta: {
                title: '在线，（内嵌iframe:打字测试、千牛实操等）'
            }
        },
        {
            path: '/train/OperationRecord',
            name: 'OperationRecord',
            component: () => import('@/page/train/newservice/OperationRecord'),
            meta: {
                title: '在线查看实操记录'
            }
        },
        // excel办公软件学习
        {
            path: '/newexcel',
            name: 'newexcel',
            component: () => import('@/page/excel/newexcel'),
            meta: {
                title: 'excel与word学习'
            }
        },
        // excel办公软件考试
        {
            path: '/excelstudy',
            name: 'excelstudy',
            component: () => import('@/page/excel/excelstudy'),
            meta: {
                title: 'excel与word考试'
            }
        },
        // 搜狗输入法的学习
        {
            path: '/typewriting',
            name: 'typewriting',
            component: () => import('@/page/typewriting/typewriting'),
            meta: {
                title: '搜狗输入法的学习'
            }
        },
        // 搜狗输入法的考试
        {
            path: '/typewritingstudy',
            name: 'typewritingstudy',
            component: () => import('@/page/typewriting/typewritingstudy'),
            meta: {
                title: '搜狗输入法的学习'
            }
        },

        {
            path: '/feiGeTrain',
            name: 'feiGeTrain',
            component: () => import('@/page/flying/training'),
            meta: {
                title: '飞鸽练习场',
                type: 'feige',
            }
        },

        {
            path: '/feiGeTrainexam',
            name: 'feiGeTrainExam',
            component: () => import('@/page/flying/feiGeTrainexam'),
            meta: {
                title: '飞鸽模拟实操',
                type: 'feige',
            }
        },
        {
            path: '/feiGeTrainexam_11618',
            name: 'feiGeTrainExam_11618',
            component: () => import('@/page/flying/feiGeTrainexam_11618'),
            meta: {
                title: '飞鸽模拟实操双11618',
                type: 'feige',
            }
        },
        {
            path: '/train/FBT/courseList',
            name: 'fbtCourseList',
            component: () => import('@/page/train/FBT/courseList'),
            meta: {
                title: '淘系认证课程列表'
            }
        },
        {
            path: '/train/FBT/qianniu',
            name: 'fbtQianniu',
            component: () => import('@/page/train/FBT/qianniu'),
            meta: {
                title: '千牛'
            }
        },
        {
            path: '/train/FBT/qianniuExam',
            name: 'fbtQianniuExam',
            component: () => import('@/page/train/FBT/qianniuExam'),
            meta: {
                title: '千牛'
            }
        },
        {
            path: '/train/FBT/jingmaiChat',
            name: 'fbtJingmaiChat',
            component: () => import('@/page/train/FBT/jingmaiChat'),
            meta: {
                title: '京麦'
            }
        },
        {
            path: '/train/FBT/jingmai',
            name: 'fbtJingmai',
            component: () => import('@/page/train/FBT/jingmai'),
            meta: {
                title: '京麦'
            }
        },
        {
            path: '/train/FBT/jingmaiExam',
            name: 'fbtJingmaiExam',
            component: () => import('@/page/train/FBT/jingmaiExam'),
            meta: {
                title: '京麦'
            }
        },
        {
            path: '/train/FBT/doudian',
            name: 'fbtDoudian',
            component: () => import('@/page/train/FBT/doudian'),
            meta: {
                title: '抖店'
            }
        },
        {
            path: '/train/FBT/doudianExam',
            name: 'fbtDoudianExam',
            component: () => import('@/page/train/FBT/doudianExam'),
            meta: {
                title: '抖店'
            }
        },
        {
            path: '/train/FBT/doudianChat',
            name: 'fbtDoudianChat',
            component: () => import('@/page/train/FBT/doudianChat'),
            meta: {
                title: '抖店'
            }
        },
        {
            path: '/train/FBT/trainResult',
            name: 'fbtTrainResult',
            component: () => import('@/page/train/FBT/trainResult'),
            meta: {
                title: '实操结果'
            }
        }
    ]
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js